import React from 'react'
import { makeLazy } from 'common/lazy'
import { Box } from 'common/styled-box'

export const AlcumusLogo = makeLazy(() => import('./alcumusLogo-renderer'), 'default', <Box height={150} />)
